/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'vimeo': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#1ab7ea" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M3.486 11.03l1.238 1.578s1.547-1.207 2.104-1.207c.346 0 1.083.402 1.547 1.795s2.418 8.61 2.537 8.942c.534 1.493 1.238 4.27 3.404 4.672s4.92-1.795 6.436-3.404 7.488-8.478 7.735-12.593c.229-3.805-1.019-4.688-1.578-5.044-1.021-.65-2.723-.866-4.332-.309s-4.053 2.383-4.703 5.631c0 0 2.197-.804 3.001-.031s.588 2.475-.093 3.744-2.599 4.208-3.311 4.301c-.712.093-1.269-1.3-1.361-1.671s-1.269-5.477-1.702-8.447-2.321-3.465-3.218-3.465c-.897 0-2.444.681-7.704 5.508z"/>'
  }
})
